// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const orbeetle: PokeData = {
  "id": 826,
  "name": "orbeetle",
  "height": 4,
  "weight": 408,
  "base_experience": 253,
  "types": [
    PokeType.BUG,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "agility",
    "confuse-ray",
    "light-screen",
    "reflect",
    "mirror-coat",
    "magic-coat",
    "calm-mind",
    "bug-buzz",
    "after-you",
    "ally-switch",
    "struggle-bug",
    "psychic-terrain"
  ],
  "moves": [
    "psychic",
    "confuse-ray",
    "reflect",
    "calm-mind",
    "bug-buzz",
    "psychic-terrain",
    "synchronize",
    "psy-ball",
    "string-shot",
    "bug-bite",
    "infest",
    "healing-wish",
    "lunge"
  ],
  "evolution_chain": {
    "id": 435,
    "item": null,
    "species": [
      {
        "name": "blipbug",
        "order": 824,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dottler",
        "order": 825,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 824,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "orbeetle",
        "order": 826,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 825,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 136,
    "speed": 140,
    "ability_power": 124
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
